import { render, staticRenderFns } from "./PopAfterSalesApply.vue?vue&type=template&id=a7872d58&scoped=true&"
import script from "./PopAfterSalesApply.vue?vue&type=script&lang=js&"
export * from "./PopAfterSalesApply.vue?vue&type=script&lang=js&"
import style0 from "./PopAfterSalesApply.vue?vue&type=style&index=0&id=a7872d58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7872d58",
  null
  
)

export default component.exports